/**
 * Initial function calls to stack the navbar and fundraising announcement.
 */
stackTheNavbar();
stackTheFundraisingAnnouncement();

/**
 * Event listener for the 'onscroll' event.
 * Calls the functions to stack the navbar and fundraising announcement.
 */
document.onscroll = function (e) {
    stackTheNavbar();
    stackTheFundraisingAnnouncement();
}

/**
 * Function to add or remove the 'stacked' class to the navbar.
 * The 'stacked' class is added when the scroll position is more than 100px from the top.
 * Otherwise, the 'stacked' class is removed.
 */
function stackTheNavbar()
{
    if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
        document.getElementById("navbar").classList.add('stacked');
    } else {
        document.getElementById("navbar").classList.remove('stacked');
    }
}

/**
 * Function to add or remove the 'substacked' class to the fundraising announcement.
 * The 'substacked' class is added when the scroll position is more than 100px from the top.
 * Otherwise, the 'substacked' class is removed.
 * The function only runs if the fundraising announcement element exists on the page.
 */
function stackTheFundraisingAnnouncement()
{
    if (document.getElementById("fundraising-announcement")){
        if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
            document.getElementById("fundraising-announcement").classList.add('substacked');
        } else {
            document.getElementById("fundraising-announcement").classList.remove('substacked');
        }
    }
}
